import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import {
  ClearButton,
  DatePicker,
  SelectDropDown
} from 'components/common/Elements/Elements';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter,
  trigerResetDatePicker
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 2;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDateChange = value => {
    const key = 'lastUpdatedAt';
    checkAndSetFilter(key, value);
  };

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.role}
        input={{ value: filter.role, onChange: handleFilter }}
        name={'role'}
        label={t('activity:filters.ROLE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.UPDATED_AT')}
        input={{
          value: filter.lastUpdatedAt,
          onChange: handleDateChange
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />

      <ClearButton
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
